import React from 'react';
import { WfCartFramePreview } from '../components/frames/WfCartFramePreview';
import { siteConfig } from '../data/siteConfig';
export function Cart() {
  return <div className="mx-auto max-w-page px-5 py-14 md:px-10 md:py-20" data-id="element-394" data-mp="13fj55ef4qhgk">
      <h1 className="font-display text-[46px] font-medium leading-tight text-ink md:text-[60px]" data-id="element-395" data-mp="ygppbfcdeed8">Your bag</h1>
      <div className="mt-12" data-id="element-396" data-mp="tixv2eo96g5v">
        <WfCartFramePreview data-id="element-397" data-mp="phcdig0rxdpc" />
      </div>
      <p className="mt-12 text-[14px] text-ink-muted" data-id="element-398" data-mp="pie2loemk0q2">
        Need help with your order? Call{' '}
        <a href={siteConfig.support.phoneHref} className="font-medium text-ink underline underline-offset-4" data-id="element-399" data-mp="kq459nb6jydr">
          {siteConfig.support.phone}
        </a>
        .
      </p>
    </div>;
}